// src/utils/api.js

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const apiFetch = async (endpoint, options = {}) => {
  const token = localStorage.getItem('access_token'); // 💡 確認したトークン名に合わせています

  // 1. デフォルトのヘッダーを準備（最初は Content-Type を入れない）
  const headers = {
    'Authorization': `Bearer ${token}`,
    ...options.headers,
  };

  // 2. 🌟 ここが超重要！
  // 送るデータ(body)が FormData「以外」の場合だけ JSON の名札を貼る
  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }
  // ※ options.body が FormData の場合は、ブラウザに任せるため何も貼らない！

  // 3. fetch を実行
  const config = {
    ...options,
    headers,
  };

  // 環境に合わせてベースURLを付与（例: http://localhost:8000/api）
  const url = `${API_BASE_URL}${endpoint}`;

  return fetch(url, config);
};